export default "__VITE_ASSET__DOdXRX$x__"